import { FormControl, FormGroup } from "@angular/forms";

export enum EsopType {
  pre = 'pre-money',
  post = 'post-money',
}

export interface GetPredictionParams {
  esopPercentage: number;
  esopType: EsopType;
  preMoney: number;
  holdingBeforeRoundPercentage: number;
  investment: number;
  round: number;
  targetHolding: number;
  totalConvertibles: number;
  discount: number;
  fundsLoan: number;
}

export interface GetPredictionsParams {
  esopPercentage: number;
  esopType: EsopType;
  preMoney: number;
  holdingBeforeRoundPercentage: number;
  investments: number[];
  rounds: number[];
  targetHolding: number;
  totalConvertibles: number;
  discounts: number[];
  fundsLoan: number;
}

export class LoanTableData {
  preMoney: string;
  discount: string;
  conversion: ConversionType;
  fundsConversionValue: string;
}

export enum ConversionTerm {
  WithinCap = 'Pre-money',
  AboveCap = 'Post-money'
}

export enum ConversionType {
  Discount = 'Discount',
  Cap = 'CAP',
  RoundPPS = 'Round PPS',
}

export class LoanConversion {
  isLoan: boolean;
  totalConvertibles: number;
  fundConvertibles: number;
  conversionTerm: ConversionTerm;
  discountRate: number;
  cap: number;
}

export class LoanDTO {
  isLoan: boolean;
  totalConvertibles: number;
  fundsLoan: number;
  discounts: number[] = [];
}


export type LoanConversionFormGroup = FormGroup<{
  isLoan: FormControl<boolean>;
  totalConvertibles: FormControl<number>;
  fundConvertibles: FormControl<number>;
  conversionTerm: FormControl<ConversionTerm>;
  discountRate: FormControl<number>;
  cap: FormControl<number>;
}>


export class LoanTableSideNavHeaders {
  preMoney: 'Pre-money';
  conversion: 'Conversion';
  discount: 'Discount';
  fundsConversionValue: 'Funds conversion value';
};

export type LoanTableSideNavHeadersKeys = keyof LoanTableSideNavHeaders;
